import { render, staticRenderFns } from "./DashboardMasterdata.vue?vue&type=template&id=8330a70c&"
import script from "./DashboardMasterdata.vue?vue&type=script&lang=js&"
export * from "./DashboardMasterdata.vue?vue&type=script&lang=js&"
import style0 from "./DashboardMasterdata.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VCol,VFileInput,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8330a70c')) {
      api.createRecord('8330a70c', component.options)
    } else {
      api.reload('8330a70c', component.options)
    }
    module.hot.accept("./DashboardMasterdata.vue?vue&type=template&id=8330a70c&", function () {
      api.rerender('8330a70c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/System/DashboardMasterdata.vue"
export default component.exports